/**
 * Records the Order.
 */
var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

export default function recordDataOrder(sState, p, order, license, licenseexpiry, dispatch, status, companyType) {

    //console.log("recordDataOrder called " +sState.reportgeom.area);
    const abortController = new AbortController();
    const request = {   
        userid: sState.userid,
        ident: sState.ident,
        companytype: companyType,
        accountid: sState.aid,
        userref: sState.userreference,
        projectname: sState.projectreference,
        price: p.price,
        royalty: 0,
        vat: p.vat,
        order: order,
        status: status,
        license: license,
        licenseexpiry: licenseexpiry,
        geometry: sState.reportgeom.geometry,
        area: sState.reportgeom.area
    };

    let mounted = true;
    (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/order/report', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request),
        signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          let oid = 0;
          if (data.status === "success"){ oid = data.orderid; } else { oid = -1; console.log("error: "+data.status)}
          dispatch({
            type: "setorderid",
            payload: { orderid: oid}
          });
        }
        const cleanup = () => {
            mounted = false;
            abortController.abort();
        };
        return cleanup;
    
    })();
}